/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const buttonStyles = {
    width: '40px',
    height: '40px',
    p: 0,
    textTransform: 'uppercase',
    _disabled: {
        color: 'borderGray',
        borderColor: 'borderGray',
        backgroundImage:
            'linear-gradient(to top left, white calc(50% - 1px), borderGray, white calc(50% + 1px) )',
        pointerEvents: 'none',
        cursor: 'not-allowed'
    }
}

export default {
    baseStyle: {
        shopLookDrawerButton: {
            position: 'absolute',
            right: '10px',
            bottom: '10px',
            background: 'white',
            padding: '20px',
            marginBottom: {base: '20px', md: 'none', lg: 'none'}
        },
        completeLookDrawerButton: {
            position: 'absolute',
            left: '50%',
            transform: 'translate(-50%, calc(-100% - 10px))',
            top: 0,
            marginTop: '125%',
            color: 'white',
            background: 'black',
            padding: '20px'
        },
        productPrice: {
            display: {base: 'flex', md: 'flex', lg: ''},
            gap: {base: '6px', md: '6px', lg: ''}
        },
        productName: {
            fontSize: '2xl',
            textTransform: 'uppercase',
            pb: 6
        },
        sizeButtons: {
            p: '24px 0'
        },
        sizeButton: {
            ...buttonStyles,
            color: 'darkGray',
            borderColor: 'gray'
        },
        sizeButtonSelected: {
            ...buttonStyles,
            color: 'white',
            borderColor: 'black'
        }
    }
}
